import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import BasicBarGraph from '../../../components/graphs/BasicBarGraph';
import api from '../../../lib/api';
import UserTableModal from '../modals/UserTableModal';
import '../../../components/styles/simpleTable.css';
import LoadingOverlay from 'react-loading-overlay';

const styles = {
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'between',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
  title: {
    textAlign: 'center',
    marginTop: '2rem',
    marginBottom: '2rem',
  },
  formItem: {
    width: '20%',
    flexGrow: 1,
    paddingRight: '10px',
  },
  formSubmit: {
    alignSelf: 'end',
    flexGrow: 1,
  },
  formSubmitBtn: {
    width: '100%',
    color: 'white',
    padding: '11px',
    borderRadius: '3px',
    backgroundColor: '#2196f3',
    border: '1px solid #2196f3',
    cursor: 'pointer',
  },
  formInput: {
    width: '95%',
    marginTop: '5px',
    padding: '10px',
  },
};

class LastLoginGraphCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      data: null,
      xAxis: [],
      yAxis: [],
      isModalOpen: false,
      modalLoginDate: '',
      modalUsers: [],
      form: {
        start_date: '',
        end_date: '',
        user_id: '',
      },
    };
  }

  componentDidMount() {
    const { startDate, endDate } = this.getStartingDates();

    this.setState({
      form: {
        start_date: startDate,
        end_date: endDate,
        user_id: '',
      },
    });

    this.filterResults();
  }

  handleChange = event => {
    const { name, value } = event.target;

    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }));
  };

  handleSubmit = event => {
    event.preventDefault();
    this.filterResults();
  };

  handleSeriesClick = serie => {
    this.setState({ loading: true });
    api({
      url: `/dashboard/find_last_logins_date?date=${serie.name}&user_id=${this.state.form.user_id || ''}`,
      method: 'GET',
    })
      .then(({ data: users }) => {
        this.setState({ modalLoginDate: serie.name });
        this.setState({ modalUsers: users });
        this.openModal();
      })
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ loading: false }));
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  getStartingDates = () => {
    const today = new Date();
    const monthLeading0 = today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : `${today.getMonth() + 1}`;
    const startDate = `${today.getFullYear()}-${monthLeading0}-01`;
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const endDate = `${endOfMonth.getFullYear()}-${monthLeading0}-${endOfMonth.getDate()}`;

    return {
      startDate: startDate,
      endDate: endDate,
    };
  };

  filterResults = () => {
    const { startDate, endDate } = this.getStartingDates();

    this.setState({ loading: true });

    api({
      url: `/dashboard/last_logins_date_count?start_date=${this.state.form.start_date || startDate}&end_date=${this
        .state.form.end_date || endDate}&user_id=${this.state.form.user_id || ''}`,
      method: 'GET',
    })
      .then(({ data }) => {
        let xAxis = [];
        let yAxis = [];

        this.setState({ loading: false });

        data.forEach((axis, index) => {
          const { login_date_count: yAxisItem, login_date: xAxisItem } = axis;

          yAxis[index] = yAxisItem;
          xAxis[index] = xAxisItem;
        });

        this.setState({ xAxis: xAxis, yAxis: yAxis });
      })
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { classes } = this.props;
    const { loading, error, form, xAxis, yAxis } = this.state;

    if (error) return <p>Error: {error.message}</p>;

    const getActiveSubscription = item =>
      item.subscriptions.find(
        sub =>
          new Date(sub.start_at).getTime() <= new Date().getTime() &&
          new Date().getTime() < new Date(sub.end_at).getTime(),
      );

    return (
      <React.Fragment>
        <LoadingOverlay
          styles={{
            overlay: base => ({
              ...base,
              background: '#2196f357',
              borderRadius: '10px',
            }),
          }}
          active={loading}
          spinner
          text="Caricamento..."
        >
          {/* Conversion Pie */}
          <div style={{ marginTop: '1rem' }}>
            <Card style={styles.card}>
              <h2 className={classes.title}>Storia dei login</h2>

              <form className={classes.form} onSubmit={this.handleSubmit}>
                <div className={classes.formItem}>
                  <label htmlFor="start_date">Dal</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="start_date"
                      type="date"
                      value={form.start_date}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formItem}>
                  <label htmlFor="end_date">Al</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="end_date"
                      type="date"
                      value={form.end_date}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formItem}>
                  <label htmlFor="user_id">ID utente</label>
                  <div>
                    <input
                      className={classes.formInput}
                      name="user_id"
                      type="number"
                      min="1"
                      value={form.user_id}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>

                <div className={classes.formSubmit}>
                  <button type="submit" className={classes.formSubmitBtn}>
                    Filtra
                  </button>
                </div>
              </form>

              <BasicBarGraph xAxis={xAxis} yAxis={yAxis} handleSeriesClick={this.handleSeriesClick} />
            </Card>
          </div>

          <UserTableModal
            title={`Utenti con login il ${this.state.modalLoginDate}`}
            closeModal={this.closeModal}
            isModalOpen={this.state.isModalOpen}
            users={this.state.modalUsers}
          />
        </LoadingOverlay>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(LastLoginGraphCard);



// WEBPACK FOOTER //
// ./src/resources/dashboard/graphs/LastLoginGraphCard.jsx